// extracted by mini-css-extract-plugin
export default {"title":"_3e331a6e27","inner_title":"_504760fec8","charge_btn":"_67055bfa50"};